import CloseIcon from "@mui/icons-material/CloseRounded";
import EmailIcon from "@mui/icons-material/EmailOutlined";
import { IconButton, InputAdornment, Stack, TextField } from "@mui/material";
import type { Dispatch, SetStateAction } from "react";
import type { NewContactEntry, NewContactState } from "./newContactState";
import { removeContactAction, updateContactFieldAction } from "./newContactState";

interface Props {
  contact: NewContactEntry;
  contactIndex: number;
  removable: boolean;
  setState: Dispatch<SetStateAction<NewContactState>>;
}

const ContactFieldsRow = ({ contact, contactIndex, removable, setState }: Props) => {
  return (
    <Stack direction="row" spacing={2} sx={{ alignItems: "flex-start" }}>
      <TextField
        required
        fullWidth
        label="Full Name"
        variant="outlined"
        value={contact.values.fullName}
        onChange={(e) => setState(updateContactFieldAction(contactIndex, "fullName", e.target.value))}
        error={!!contact.errors.fullName}
        helperText={contact.errors.fullName}
      />
      <TextField
        required
        fullWidth
        label="Email"
        variant="outlined"
        value={contact.values.email}
        onChange={(e) => setState(updateContactFieldAction(contactIndex, "email", e.target.value))}
        error={!!contact.errors.email}
        helperText={contact.errors.email}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon color="action" />
              </InputAdornment>
            ),
          },
        }}
      />
      {removable && (
        <IconButton onClick={() => setState(removeContactAction(contactIndex))}>
          <CloseIcon />
        </IconButton>
      )}
    </Stack>
  );
};

export default ContactFieldsRow;
